export const createDefaultLayout = () => ({
  navWidth: 200,
  navAnchor: 'left',
  navVariant: 'persistent',
  collapsible: true,
  collapsedWidth: 64,
  clipped: true,
  headerPosition: 'sticky',
  squeezed: true,
  footerShrink: true,
});

export const createContentBasedLayout = config => ({
  ...createDefaultLayout(),
  navWidth: 256,
  navVariant: 'persistent',
  collapsible: true,
  ...config,
});
